import React, { StrictMode } from 'react';
import PropTypes from 'prop-types';

import ClaimContext from 'contexts/ClaimContext';
import Main from './Main';

export default function Index({ isPossibleAddClaim }) {
  return (
    <StrictMode>
      <ClaimContext>
        <Main isPossibleAddClaim={isPossibleAddClaim} />
      </ClaimContext>
    </StrictMode>
  );
}

Index.propTypes = {
  isPossibleAddClaim: PropTypes.bool,
};

Index.defaultProps = {
  isPossibleAddClaim: false,
};
